import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop Component
 * 
 * Automatically scrolls to top of page on every route change.
 * This ensures consistent scroll behavior across the entire app.
 * 
 * Features:
 * - Triggers on pathname changes
 * - Triggers on search param changes (e.g., ?tab=billing)
 * - Uses instant scroll for fast, lag-free navigation
 * - Works on both desktop and mobile
 */
export default function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Scroll to top immediately on route change
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Use instant for fast, no-lag scrolling
    });
    
    // Also reset any scrollable containers within the page
    const scrollableElements = document.querySelectorAll('[data-scroll-container]');
    scrollableElements.forEach(el => {
      el.scrollTop = 0;
    });
  }, [pathname, search]);

  return null; // This component doesn't render anything
}
